import { request } from "@/api";
import type { PaymentOptionBase, PaymentOptionMy } from "@/shared/types";

export const fetchPaymentOptions = async () => {
  return await request<PaymentOptionBase[]>("/payment-options/base");
};

export const fetchMyOptions = async () => {
  return await request<PaymentOptionMy[]>("/payment-options/my");
};

export const postMyOption = async (baseId: number, description: string) => {
  return await request<{ createdUpoId: number }>("/payment-options/my", {
    method: "POST",
    body: { baseId, description },
  });
};

export const updateMyOption = async (editId: number, description: string) => {
  return await request("/payment-options/my", {
    method: "POST",
    body: { description, editId },
  });
};

export const deleteOption = async (editId: number) => {
  return await request("/payment-options/my", {
    method: "DELETE",
    body: { editId },
  });
};
